module.exports = __webpack_public_path__ + "media/images/countrysquared/zz-b0194ffffe44e772f2b900ac77193f1d.svg";